import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { getProductSuggestion } from 'actions/EntityActions';
import DialogInput from 'screens/components/advanced/DialogInput';
import CustomButton from 'screens/components/basic/Button';
import Divider from '@mui/material/Divider';
import DialogHeader from 'screens/components/basic/DialogHeader';
import POSPatient from './POSPatient';
import POSProductCard from './POSProductCard';
import POSProductDetails from './POSProductDetails';
import Button from '@mui/material/Button';

const dialogStyle = {
    width: '70%',
    maxWidth: 'none'
};

const compName = 'POSProductSuggestion';

class POSProductSuggestion extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            patientDialog: false,
            continue: false,
            openDialogAddProduct: false,
            isAddingProduct: false
        };
    }

    componentWillReceiveProps(newProps) {
        if (this.props.isOpen === false && newProps.isOpen === true) {
            if (this.props.posOrder && this.props.posOrder.patientId &&
                (!this.props.posProductSuggestions || this.props.posOrder.patientId != this.props.posProductSuggestions.patientId)) {
                this.getProductSuggestion(this.props.posOrder.patientId)
            }
        }
    }

    getProductSuggestion = (patientId) => {
        let model = {
            branchId: this.props.branchId,
            patientId: patientId
        }

        this.props.getProductSuggestion(model);
    }

    openPatientDialog = () => {
        this.setState({ patientDialog: true });
        window.removeEventListener("keypress", this.barcodeListener);
    }

    closePatientDialog = () => {
        this.setState({ patientDialog: false });
        this.props.onClose();
        window.addEventListener("keypress", this.barcodeListener);
    }

    continue = () => {
        this.setState({ continue: true });
        this.getProductSuggestion(0);
    }

    closeAddProductDialog = () => {
        this.setState({ openDialogAddProduct: false });
        this.props.updateDialogProduct(null);
    }


    render() {
        const { t } = this.props; 
        const p = this.props;
        const s = this.state;

        const actions = [
            <CustomButton
                key={1}
                type="CancelButton"
                className="btn-space"
                label={t('common.cancel')}
                secondary={true}
                onTouchTap={() => p.onClose()}
            />,
        ];

        let patientId = p.posOrder ? p.posOrder.patientId : 0
        let patientName = patientId != 0 ? `${t('pos.productSuggestion.for')} ${p.posOrder.patientFirstName} ${p.posOrder.patientLastName}` : ""


        return (
            <DialogInput
                title={<DialogHeader text={`${t('pos.productSuggestion.productSuggestion')} ${patientName}`} classicClass="posDialogClassic" />}
                actions={actions}
                modal={true}
                open={p.isOpen}
                autoScrollBodyContent={true}
                contentStyle={dialogStyle}>
                <div className="row">
                    {patientId == 0 && !s.continue ?
                        <div style={{ alignItems: "center", justifyContent: "center" }}>
                            <h4> {t('pos.productSuggestion.memberSuggestion')}:</h4>
                            <Button
                                fullWidth={false}
                                sx={{ width: 300, margin: "auto", color: "#FFFFFF" }}
                                variant='contained'
                                onClick={() => this.openPatientDialog()}
                            >{t('pos.productSuggestion.linkMember')}</Button>
                            <br />
                            <br />
                            <h4>{t('pos.productSuggestion.generalSuggestion')}:</h4>
                            <Button
                                fullWidth={false}
                                variant='contained'
                                sx={{ width: 300, margin: "auto", color: "#FFFFFF" }}
                                onClick={() => this.continue()}
                            >{t('pos.productSuggestion.continue')}</Button>
                        </div> :
                        <div>
                            <div className="row-flex shop_product_container">
                                {p.posProductSuggestions != null && p.posProductSuggestions.list.length > 0 ?
                                    p.posProductSuggestions.list.map((item, index) => {

                                        return (
                                            p.showImageInPOSPage ?
                                                <div key={index}>
                                                    <h4 className="text-center primary-color-bg text-white">{index + 1}</h4>
                                                    <POSProductCard openDetailLog={() => this.props.addToOrder(item)} item={item} />
                                                </div>
                                                :
                                                <CustomButton type="button" className="btn btn-grid sale_products_button" onTouchTap={() => this.props.addToOrder(item)} key={index}>
                                                    <div>{item.name}</div>
                                                </CustomButton>
                                        );
                                    }) : <p>{t('pos.productSuggestion.memberNoHistory')}</p>
                                }
                            </div>
                            <br />
                            <Divider />
                            <br />
                            {patientId == 0 ?
                                <p>
                                    <Button
                                        variant='contained'
                                        fullWidth={false}
                                        sx={{ width: 180, margin: "auto", color: "#FFFFFF" }}
                                        onClick={() => this.openPatientDialog()}
                                    >{t('pos.productSuggestion.linkMember')}</Button>
                                    &nbsp;&nbsp; <b>{t('pos.productSuggestion.toGetMemberSpecificSuggestions')}</b>
                                </p> : null
                            }

                        </div>
                    }

                </div>
                <POSPatient name="POSPatient" isOpen={s.patientDialog} onClose={() => this.closePatientDialog()} />
            </DialogInput>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        branchId: state.common.branchId,
        posOrder: state.entity.posOrder,
        posProductSuggestions: state.entity.posProductSuggestions,
        showImageInPOSPage: state.common.applicationSettings.showImageInPOSPage,
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        getProductSuggestion: (model) => dispatch(getProductSuggestion(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSProductSuggestion))